module.exports = __webpack_public_path__ + "static/media/maio_logo.f8f89a55.svg";